import { render, staticRenderFns } from "./CarouselDotStyleProperty.vue?vue&type=template&id=8958946e&"
import script from "./CarouselDotStyleProperty.vue?vue&type=script&lang=js&"
export * from "./CarouselDotStyleProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports